import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=0a3d213a&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=0a3d213a&prod&scoped=true&lang=css"
import style1 from "./OrderManagement.vue?vue&type=style&index=1&id=0a3d213a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d213a",
  null
  
)

export default component.exports